
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import VueMarkdown from "vue-markdown";

import { cssStripe, getThemeColor, palette } from "../../palette";

@Component({
  components: { VueMarkdown },
  filters: {},
})
export default class LatestNews extends Vue {
  cssStripe = cssStripe;
  getThemeColor = getThemeColor;

  get stripeColor() {
    // return getThemeColor('primary');
    return palette.grey["300"];
  }

  newsItems: any[] = [
    {
      date: "16-Feb-2023",
      title: "nf-core/rnaseq update",
      text:
        "We have updated Laxy to use the latest <a href=\"https://nf-co.re/rnaseq\">nf-core/rnaseq</a> pipeline, v3.10.1, as the default. This brings a few advantages over the previous version available in Laxy, namely automatic detection of the 'strandedness' of your data. We've also added some post-pipeline steps to provide a traditional featureCounts count matrix, similar to the output of RNAsik, and added a biotypes column to the nf-core/rnaseq counts matrix (generated by <a href=\"https://combine-lab.github.io/salmon/\">Salmon</a>). nf-core/rnaseq is now considered the preferred default RNA-seq pipeline in Laxy - RNAsik has served us well, but the rapid refinement of the nf-core/rnaseq pipeline by the community means it makes more sense to use it going forward. The legacy RNAsik pipeline will still be available for the forseeable future.",
    },
  ];
}
